import React, { useState, useEffect } from 'react';
import './Pages.css';

const Plane = () => {
  const [rates, setRates] = useState({});
  const [timelineEvents, setTimelineEvents] = useState([]);

  useEffect(() => {
    // Load rates data from CMS API
    const loadRatesData = async () => {
      try {
        // Use Netlify Functions in production, localhost in development
        const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const apiUrl = isDevelopment 
          ? 'http://localhost:3001/api/cms/rates' 
          : '/.netlify/functions/cms-rates';
        
        const response = await fetch(apiUrl);
        if (response.ok) {
          const ratesData = await response.json();
          if (ratesData.length > 0) {
            setRates(ratesData[0]); // Use first rate entry
              } else {
                // Fallback data
                setRates({
                  rate_per_hour: 134.00,
                  monthly_dues: 123.00
                });
              }
        } else {
          console.error('Failed to fetch rates:', response.status);
          // Fallback data
          setRates({
            rate_per_hour: 134.00,
            monthly_dues: 123.00
          });
        }
      } catch (error) {
        console.error('Error loading rates data:', error);
        // Fallback data
        setRates({
          rate_per_hour: 134.00,
          monthly_dues: 123.00
        });
      }
    };

    // Load avionics/timeline data (static - not from CMS)
    const loadTimelineData = async () => {
      try {
        const timelineData = [
          { year: 2023, event: "Fine tooth comb Annual at Fletchair in Texas" },
          { year: 2020, event: "New Paint" },
          { year: 2019, event: "Garmin GFC 500 Autopilot installed" },
          { year: 2018, event: "New powder coated instrument panel. Garmin GTN 650; G5 AI; G5 HSI; PMA 450B audio panel; all new switches, breakers & panel lighting." },
          { year: 2017, event: "Penn Yan Engine overhaul; Electroair Electronic ignition." },
          { year: 2016, event: "Garmin GNC 255A navcomm & Garmin GTX 345 ADS-B Transponder replace Bendix King components." },
          { year: 2015, event: "New ABS interior trim, New headliner; SoundEx composite soundproofing; USB charger jacks." },
          { year: 2011, event: "Factory Annual Inspection." },
          { year: 2010, event: "KT 73 Mode S transponder; KMA 28 Audio Panel; JPI EDM 830 color display; Alpha Systems AOA indicator; Mitchell Engine gauges; New Rosewood panel overlay." },
          { year: 2009, event: "New leather seats and front side panels; new carpet; new seat belts; XeVision HID landing light." },
          { year: 2008, event: "Engine overhaul" },
          { year: 2001, event: "KLN 94 Color Map IFR GPS; S-Tec 20 Autopilot; KX 165 w/GS; JPI EDM 800 engine monitor; Tannis preheater; Whelen Strobes; all new windows; all new wiring - panel to spinner." }
        ];
        setTimelineEvents(timelineData);
      } catch (error) {
        console.error('Error loading timeline data:', error);
      }
    };

    loadRatesData();
    loadTimelineData();
  }, []);

  return (
    <div className="page">
      <div className="plane-content">
        <div className="plane-description">
        <div className="pricing-card">
          <h2>Affordable Flying with No Daily Minimums</h2>
          <ul className="pricing-list pb-5">
            <li><strong>${rates.rate_per_hour || 134.00}</strong> per <strong>TACH hour (wet)</strong></li>
            <li><strong>${rates.monthly_dues || 123.00}</strong> monthly membership dues</li>
          </ul>

          <p className="highlighted-message">
            <strong>Fly 20+ hours a year?</strong><br />
            We're your most cost-effective option.
          </p>
        </div>
        </div>

        <div className="timeline-section">
          <h2>Maintenance & Upgrade History</h2>
          <div className="timeline">
            {timelineEvents.map((event, index) => (
              <div key={index} className="timeline-card">
                <div className="timeline-year">{event.year}</div>
                <div className="timeline-content">
                  <p>{event.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plane; 